<template>
  <div class="quote">
    <p class="quote-text">
      “{{ quote }}”
    </p>

    <span class="quote-person">{{ person }}</span>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    quote: {
      type: String,
      default: ''
    },

    person: {
      type: String,
      default: ''
    }
  }
})
</script>

<style>
  .quote {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;
    text-align: center;
  }

  .quote-text {
    font-size: 1.4rem;
    margin: 10px 0;
  }

  .quote-person {
    font-size: 1.6rem;
  }

  @media screen and (max-width: 800px) {
    .quote {
      width: 100%;
    }
  }
</style>
